export default __webpack_public_path__ + "static/media/Alert.5166046b.svg";